module.exports = __webpack_public_path__ + "img/2.b5ad593a.jpg";